import { UseToastOptions, useToast } from "@chakra-ui/react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

function ErrorService() {
  const { t } = useTranslation();
  const toast = useToast();

  useEffect(() => {
    const errorCallback = ((error: CustomEvent<UseToastOptions>) =>
      toast({
        title: t("common.labels.an_error_occurred"),
        isClosable: true,
        ...error.detail,
        status: "error",
      })) as unknown as EventListenerOrEventListenerObject;

    window.addEventListener("app-error", errorCallback);

    return () => {
      window.removeEventListener("app-error", errorCallback);
    };
  }, [t, toast]);

  return null;
}

export default ErrorService;
